export interface Planet {
  name: string;
  symbol: string;
}

export const planets: Planet[] = [
  { name: "Saturn", symbol: "♄" },
  { name: "Jupiter", symbol: "♃" },
  { name: "Marte", symbol: "♂" },
  { name: "Soare", symbol: "☉" },
  { name: "Venus", symbol: "♀" },
  { name: "Mercur", symbol: "☿" },
  { name: "Luna", symbol: "☽" },
];

// Days of the week planetary rulers (day starts with the ruler)
export const dayRulers: Record<number, string> = {
  0: "Soare", // Sunday
  1: "Luna", // Monday
  2: "Marte", // Tuesday
  3: "Mercur", // Wednesday
  4: "Jupiter", // Thursday
  5: "Venus", // Friday
  6: "Saturn", // Saturday
};
